import React, { useState } from 'react';
import { Loader, Label } from '../../../UiKit';
import { LeftTriangleSmall } from 'sushiweb/Icons';
import { green } from 'sushiweb/tokens/color';
import { EmptyState, AddInstructions } from '../../commons';
import {
  InvalidSearchImg,
  singleTick,
  doubleTick,
} from '../../../images/images';
import styled from 'styled-components';

export const Instructions = ({
  orderId = null,
  isLoading = true,
  isError = false,
  errorMsg = '',
  instructions = null,
  close = () => {},
}) => {
  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return (
      <div className='pt20 pb20'>
        <EmptyState img={InvalidSearchImg} heading={errorMsg} />
      </div>
    );
  }

  return (
    <React.Fragment>
      {instructions &&
        instructions.map((item, index) => {
          return (
            <SingleInstruction
              item={item}
              close={close}
              key={index}
              orderId={orderId}
            />
          );
        })}
    </React.Fragment>
  );
};

const SingleInstruction = ({ item, orderId, close = () => {} }) => {
  const [isTextBoxOpen, setTextBoxOpen] = useState(false);

  let editText = item?.instructions?.length
    ? 'Edit instructions'
    : 'Add instructions';

  const checkIfTextBoxIsOpen = (isOpen) => {
    setTextBoxOpen(isOpen);
  };

  return (
    <Instructions.Wrapper>
      <div className='col'>
        <p className='lighter large mb10'>{item.title}</p>
      </div>
      <React.Fragment>
        {!isTextBoxOpen &&
          item.instructions.map((ele, index) => {
            return (
              <div className='mb10 mt10' key={index}>
                <p className='semiBold'>{ele.instruction_title}</p>
                <div className='instruction'>
                  <p>{ele.instruction}</p>
                  {ele?.status === 'ACCEPTED' ? (
                    <Label
                      title='Accepted'
                      bgColor='#F7FAFF'
                      textColor='#1155CB'
                      showIcon={true}
                      icon={doubleTick}
                      pos='left'
                      iconSize='2rem'
                    />
                  ) : (
                    <span className='tickImg iconMarginL'>
                      <img src={singleTick} alt='' />
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        {item.is_editable && (
          <AddInstructions
            oldInstruction={item?.instructions[0]?.instruction}
            orderId={orderId}
            item={item}
            target={item.action}
            isMxInstruction={true}
            label={
              <p className='pointer'>
                <span className='green semiBold'>{editText}</span>
                <span className='iconMarginR iconMarginL'>
                  <LeftTriangleSmall size={14} color={green.z500} />
                </span>
              </p>
            }
            checkIfTextBoxIsOpen={checkIfTextBoxIsOpen}
            submitNewInstruction={close}
          />
        )}
      </React.Fragment>
    </Instructions.Wrapper>
  );
};

Instructions.Wrapper = styled.div`
    border-top: 1px solid #EBEBEB;
    padding 3rem 2rem;

    .instruction {
        display: flex;
        justify-content: space-between;
    }
`;
